import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
export const useCreateUserContext = ({ PERMISSIONS, permissions, }) => {
    const auth0 = useAuth0();
    const getUserPropertiesFromAuth0 = () => {
        const roles = auth0?.user?.user_roles ?? [];
        return {
            user: auth0.user,
            roles,
            permissions,
        };
    };
    const [loggedInUser, setLoggedInUser] = useState(getUserPropertiesFromAuth0());
    const [impersonatingUser, setImpersonatingUser] = useState(undefined);
    const [showImpersonationModal, setShowImpersonationModal] = useState(false);
    useEffect(() => {
        setLoggedInUser(getUserPropertiesFromAuth0());
    }, [permissions]);
    useEffect(() => {
        setLoggedInUser(getUserPropertiesFromAuth0());
    }, [auth0.user]);
    const currentUser = useMemo(() => {
        return impersonatingUser?.user ? impersonatingUser : loggedInUser;
    }, [loggedInUser, impersonatingUser]);
    const isDeveloper = useCallback((useLoggedInUser = false) => {
        return (useLoggedInUser ? loggedInUser.roles : currentUser.roles).includes('developer');
    }, [loggedInUser.roles, currentUser.roles]);
    const impersonate = (impersonating) => {
        setImpersonatingUser(impersonating);
    };
    const stopImpersonating = () => {
        setImpersonatingUser(undefined);
    };
    const hasPermissions = useCallback((callback) => {
        if (isDeveloper())
            return true;
        const { permissions: requiredPermissions = [] } = callback(PERMISSIONS);
        const permissionsAreValid = requiredPermissions.length > 0
            ? requiredPermissions.every((permission) => currentUser.permissions.includes(permission))
            : true;
        return permissionsAreValid;
    }, [currentUser, isDeveloper, PERMISSIONS]);
    return {
        loggedInUser,
        impersonatingUser,
        user: currentUser,
        isImpersonating: impersonatingUser?.user !== undefined,
        isDeveloper,
        impersonate,
        stopImpersonating,
        showImpersonationModal,
        setShowImpersonationModal,
        hasPermissions,
    };
};
export const userContext = createContext(null);
export const useUserContext = () => {
    const context = useContext(userContext);
    if (!context)
        throw new Error('User context must be used within a <Auth0UserProvider/> component.');
    return context;
};
